"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.export_icon = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var export_icon = function export_icon(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'export-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.25 4.7381C3.25 4.04774 3.80964 3.4881 4.5 3.4881H8C8.41421 3.4881 8.75 3.82388 8.75 4.2381C8.75 4.65231 8.41421 4.9881 8 4.9881H4.75V15.4881H8C8.41421 15.4881 8.75 15.8239 8.75 16.2381C8.75 16.6523 8.41421 16.9881 8 16.9881H4.5C3.80964 16.9881 3.25 16.4285 3.25 15.7381V4.7381ZM13.0199 6.66193C13.3381 6.39676 13.811 6.43975 14.0762 6.75796L16.5762 9.75796C16.8079 10.0361 16.8079 10.4401 16.5762 10.7182L14.0762 13.7182C13.811 14.0364 13.3381 14.0794 13.0199 13.8143C12.7017 13.5491 12.6587 13.0762 12.9238 12.758L14.3987 10.9881H8C7.58579 10.9881 7.25 10.6523 7.25 10.2381C7.25 9.82388 7.58579 9.4881 8 9.4881H14.3987L12.9238 7.71824C12.6587 7.40003 12.7017 6.92711 13.0199 6.66193Z',
    fill: '#4B5563'
  }));
};

exports.export_icon = export_icon;